import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/LinksDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(Method.DELETE, 'links/' + idItem, null);
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('links/' + idItem);
};

export const GetListaItems = async (pathObjeto, idPadre) => {
  return DataUtils.FetchLista(pathObjeto + '/' + idPadre + '/links');
};

export const PostItem = async (codTipoObjeto, idObjeto, datosItem) => {
  return await DataUtils.SaveObject(Method.POST, 'links', DTOs.saveItem(datosItem));
};

export const PutItem = async (codTipoObjeto, idObjeto, datosItem) => {
  return await DataUtils.SaveObject(Method.PUT, 'links/' + datosItem.id, DTOs.saveItem(datosItem));
};
